import { render, staticRenderFns } from "./AnkleFeaturesChart.vue?vue&type=template&id=c9883b60&scoped=true&"
import script from "./AnkleFeaturesChart.vue?vue&type=script&lang=js&"
export * from "./AnkleFeaturesChart.vue?vue&type=script&lang=js&"
import style0 from "./AnkleFeaturesChart.vue?vue&type=style&index=0&id=c9883b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9883b60",
  null
  
)

export default component.exports